import { render } from "./SharePrice.vue?vue&type=template&id=175d6ffb"
import script from "./SharePrice.vue?vue&type=script&lang=js"
export * from "./SharePrice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GitHub\\KirillSuprunJob.github.io\\Portfolio\\AlbumPortfolio\\InfoWebPage\\info_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__